import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';

import { State, ErrorIcon, ErrorState } from './AutosaveStates.styled';

const AutosaveStates = ({ isSaving, lastSavedAt, error }) => {
  if (!isSaving && !lastSavedAt && !error) return null;

  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (!lastSavedAt) return () => {};

    if (!timeAgo) {
      // set time first time without any delay
      setTimeAgo(formatDistanceToNow(lastSavedAt));
    }

    // update the timer after every 30s
    const interval = setInterval(() => {
      setTimeAgo(formatDistanceToNow(lastSavedAt));
    }, 30 * 1000);

    // clear interval on un-mount
    return () => clearInterval(interval);
  }, [lastSavedAt]);

  const hasErrors = !isSaving && error;
  const isSuccessful = !isSaving && !hasErrors && lastSavedAt;

  return (
    <Tooltip
      title={`All changes you make are automatically saved. Last edited: ${timeAgo} ago`}
      position="bottom"
      spacing={0}
      enabled={isSuccessful}
    >
      <State aria-label="grades saving state">
        {isSaving && 'Saving...'}
        {hasErrors && (
          <ErrorState>
            <ErrorIcon />
            Not all changes were saved. Edit or re-enter a grade to save again.
          </ErrorState>
        )}
        {isSuccessful && 'All changes saved'}
      </State>
    </Tooltip>
  );
};

AutosaveStates.propTypes = {
  isSaving: PropTypes.bool.isRequired,
  lastSavedAt: PropTypes.instanceOf(Date),
  error: PropTypes.bool,
};

AutosaveStates.defaultProps = {
  lastSavedAt: null,
  error: false,
};

export default AutosaveStates;
